import { render } from "./ClientCallSquadMap.vue?vue&type=template&id=012672ea"
import script from "./ClientCallSquadMap.vue?vue&type=script&lang=js"
export * from "./ClientCallSquadMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__